<div
  class="button button__add"
  (click)="addNewDiagnosis()"
  title='Add a new diagnosis'>+</div>